import { Box, Flex, SvgIcon } from '@volue/wave-react';
import React from 'react';

import type { LvShortCircuitSummaryEvaluatedResults } from '@/features/execute-calculation-set/overmind/calculation/derived-state/shortCircuitSummary/lowVoltage/LvShortCircuitSummaryEvaluatedResults';
import type { ElectricCurrentType } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';
import { countShortCircuitIssuesRequiringAttention } from '@/features/execute-calculation-set/overmind/calculation/evaluation/shortCircuit/attentionRequired';
import { useAppState } from '@/overmind';

import { EvaluatedResultsRange } from '../../EvaluatedResultsRange';

export type LvShortCircuitummaryCalculationResultsProps = {
  shortCircuitSummary: LvShortCircuitSummaryEvaluatedResults;
};

export function LvShortCircuitSummaryCalculationResults(
  props: LvShortCircuitummaryCalculationResultsProps
) {
  const evaluatedGridElements =
    useAppState().calculation.gridElementsDetailsByCalculationType;

  const shortCircuitSummary = props.shortCircuitSummary;
  const attentionStatuses =
    useAppState().calculation.gridElementsAttentionStatuses;
  const isEvaluated =
    evaluatedGridElements.type === 'EVALUATED' &&
    attentionStatuses.type === 'AVAILABLE';

  return (
    <Box>
      <Box
        css={{
          color: '$colorAccent70',
          fontWeight: 'bold',
          fontSize: 'larger'
        }}
      >
        <Flex main={'space-between'}>
          <Box>{'Short Circuit'}</Box>
          {isEvaluated && (
            <Box
              data-testid="loadflow-attention-needed-counter"
              css={{ color: '$colorOrange70' }}
            >
              <SvgIcon iconName="warning" className="mRs" />
              {countShortCircuitIssuesRequiringAttention(
                attentionStatuses.byCalculationType
              )}
            </Box>
          )}
        </Flex>
      </Box>
      <Box>
        <SvgIcon iconName="home" className="mRm" />
        {'Energy Consumer Currents'}
      </Box>
      <Flex flow={'column'} className="w100 pLxl" gap={'spacingXs'}>
        {shortCircuitSummary.phase1Min.type ===
          'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={shortCircuitSummary.phase1Min.result}
            label={'Phase1Min'}
          />
        )}
        {shortCircuitSummary.phase1Max.type ===
          'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={shortCircuitSummary.phase1Max.result}
            label={'Phase1Max'}
          />
        )}
        {shortCircuitSummary.phase2Min.type ===
          'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={shortCircuitSummary.phase2Min.result}
            label={'Phase2Min'}
          />
        )}
        {shortCircuitSummary.phase3Max.type ===
          'CALCULATION_RESULT_AVAILABLE' && (
          <EvaluatedResultsRange<ElectricCurrentType>
            range={shortCircuitSummary.phase3Max.result}
            label={'Phase3Max'}
          />
        )}
      </Flex>
    </Box>
  );
}
